module.exports = __webpack_public_path__ + "static/media/1.25407b16.png";